// extracted by mini-css-extract-plugin
export default {"empty-profile-pic":"NavBar_empty-profile-pic__WeBfa","profile-pic":"NavBar_profile-pic__JaVjO","nav-menu":"NavBar_nav-menu__bXCIG"};